<template>
  <div v-if="tableDisplay == 'initiated_documents'">
    <!-- <v-row style="margin-top: -40px">
    </v-row> -->
    <v-row class="mb-4 px-3 mt-n1" v-if="selected.length > 0">
      <v-app-bar color="grey darken-3" dense dark>
        <v-toolbar-title class="overline"
          >{{ selected.length }} selected</v-toolbar-title
        >
        <v-divider class="ml-5 mr-2" vertical></v-divider>
        <v-btn
          depressed
          class="overline mr-2 custom-hover"
          color="grey darken-3"
          >Edit</v-btn
        >
        <v-btn
          depressed
          class="overline mr-2 custom-hover"
          color="grey darken-3"
          >Delete</v-btn
        >
        <v-btn
          depressed
          class="overline mr-2 custom-hover"
          color="grey darken-3"
          >Save as record</v-btn
        >

        <v-btn
          depressed
          class="overline mr-2 custom-hover"
          color="grey darken-3"
          @click="fetchOutputDocumentActivity()"
          >
            Document activity
          </v-btn
        >
      </v-app-bar>
    </v-row>
    <v-row class="mt-n2">
      <v-col>
        <v-data-table
          v-model="selected"
          :single-select="false"
          :items="allInitiatedDocuments"
          :headers="headers"
          :items-per-page="10"
          class="elevation-2"
          item-key="id"
          :search="search"
          show-select
        >
        </v-data-table>
      </v-col>
    </v-row>

    <v-snackbar
      v-model="snackbar"
      :timeout="timeout"
      class="pb-10"
    >
      This action requires you to select only one document

      <template v-slot:action="{ attrs }">
        <v-btn
          color="blue"
          text
          v-bind="attrs"
          @click="snackbar = false"
        >
          Close
        </v-btn>
      </template>
    </v-snackbar>

    <OutputDocumentActivity
      :dialog="document_activity_dialog"
      :transactionId="selected_transaction_id"
      @closeDialog="closeOutputActivityDialog"
    />
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import OutputDocumentActivity from './OutputDocumentActivty';

export default {
  name: "InitiatedDocumentsList",
  props: {
    tableDisplay: String,
    search: String,
  },
  components: {
    OutputDocumentActivity
  },
  data() {
    return {
      headers: [
        {
          text: "Name",
          align: "start",
          sortable: true,
          value: "name",
        },
        { text: "Title", value: "title" },
        { text: "Subject", value: "subject" },

        { text: "Type", value: "type" },
        { text: "Tag", value: "tag" },
        { text: "Sender", value: "sender" },
        { text: "Address", value: "address" },
      ],
      selected: [],
      singleSelect: false,
      snackbar: false,
      timeout: 5000,
      document_activity_dialog: false,
      selected_transaction_id: null,
    };
  },
  methods: {
    archive() {
      alert("archving");
    },
    edit() {
      alert("editing");
    },
    fetchOutputDocumentActivity() {
      if(this.selected.length > 1) {
        this.snackbar = true;
      } else {
        this.document_activity_dialog = true;
        this.selected_transaction_id = this.selected[0].transaction_id;
      }

    },
    closeOutputActivityDialog() {
      this.document_activity_dialog = false;
    }
  },
  computed: mapGetters(["allInitiatedDocuments"]),
};
</script>

<style>
</style>